import { axios } from '@/ajax/config'

// 全局属性：存储完善信息弹窗配置
/* 
{
  "showTest": true,
  "startDate": "2025-11-27 10:00",
  "endDate": "2025-12-28 10:00",
  "tests": [
    {
      "name": "ATest",
      "proportion": 30,
      "cancelable": false,
      "img": "",
      "score": 0,
      "page_source": "工具完善-强制",
      "infoCompleteType": "A"
    },
    {
      "name": "BTest",
      "proportion": 70,
      "cancelable": true,
      "img": "",
      "score": 500,
      "page_source": "工具完善-激励",
      "infoCompleteType": "B"
    }
  ]
}
*/
let prefectToastConfig = null; // 完善信息弹窗整体配置
let userPlan = null; // 用户对应的AB测试配置
let showTest = false; // 是否启用AB测试
let isInActiveTime = false; // 是否在活动时间内
let configInitPromise = null; // 配置初始化 Promise，用于等待配置加载完成

/**
 * 判断当前时间是否在活动时间范围内（精确到分钟）
 * @param {string} startDate - 开始日期 YYYY-MM-DD HH:mm
 * @param {string} endDate - 结束日期 YYYY-MM-DD HH:mm
 * @returns {boolean} 是否在活动时间内
 */
function checkIsInActiveTime(startDate, endDate) {
  if (!startDate || !endDate) {
    return false;
  }
  // 仅保留到分钟，去掉秒和毫秒部分
  const now = new Date();
  now.setSeconds(0, 0);

  // 支持"YYYY-MM-DD HH:mm"、"YYYY/MM/DD HH:mm"等格式
  const parseDate = (str) => {
    // 兼容字符串中间有空格
    let date = str.replace(/-/g, "/");
    return new Date(date);
  };

  const start = parseDate(startDate);
  const end = parseDate(endDate);

  // 将 start 和 end 的秒和毫秒去掉，精确到分钟
  start.setSeconds(0, 0);
  end.setSeconds(59, 999); // 包含活动结束这1分钟

  return now >= start && now <= end;
}


/**
 * 获取完善信息弹窗配置
 * @returns {Promise<Object>} 配置对象
 */
async function getPrefectToastConfig() {
  // 如果已经有初始化 Promise，直接返回等待它
  if (configInitPromise) {
    return configInitPromise;
  }
  
  // 如果已经有缓存配置，直接返回
  if (prefectToastConfig) {
    return prefectToastConfig;
  }
  
  // 创建初始化 Promise
  configInitPromise = (async () => {
    try {
      // 从阿里云JSON配置获取数据
      const apiUrl = Global_AliJson_path + 'doctor_tools_prefectToast';
      
      // 使用全局的axios实例获取配置
      const response = await axios.get(apiUrl)
      if (response.status == 200 && response.data) {
        const data = response.data
        prefectToastConfig = data;
        console.log('完善信息弹窗配置加载成功:', prefectToastConfig);
        
        // 更新全局参数
        showTest = !!prefectToastConfig.showTest;
        isInActiveTime = checkIsInActiveTime(
          prefectToastConfig.startDate, 
          prefectToastConfig.endDate
        );
        
        console.log(`AB测试状态: showTest=${showTest}, isInActiveTime=${isInActiveTime}`);
        
        // 如果启用AB测试且在活动时间内，则获取用户对应配置
        if (showTest && isInActiveTime) {
          await getUserInfoCompletePlan();
        }
        
        return prefectToastConfig;
      } else {
        console.warn('获取完善信息弹窗配置失败:', response.status);
        return null;
      }
    } catch (error) {
      console.error('获取完善信息弹窗配置出错:', error);
      return null;
    }
  })();
  
  return configInitPromise;
}

/**
 * 等待配置初始化完成
 * @returns {Promise<void>}
 */
async function waitForConfigInit() {
  if (configInitPromise) {
    await configInitPromise;
  }
}

/**
 * 获取当前用户的 AB测试方案
 * @returns {Promise<Object|null>} 用户方案对象或 null
 */
async function getUserPlan() {
  // 等待配置初始化完成
  if (configInitPromise) {
    await configInitPromise;
  }
  
  console.log('getUserPlan 返回:', userPlan);
  return userPlan;
}

/**
 * 获取用户对应的AB测试配置
 * @returns {Promise<void>}
 */
async function getUserInfoCompletePlan() {
  if (!window.head.auth) {
    return null;
  }

  try {
    const apiUrl = Global_apiserver + 'api/user/v3/getUserInfoCompletePlan';
    let postData = {
      head,
    }
    const response = await axios.post(apiUrl, postData);
    if (response.status === 200 && response.data && response.data.infoCompleteType) {
      userPlan = response.data;
      // userPlan = {
      //   "name": "ATest",
      //   "cancelable": false,
      //   "img": "https://rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/SQtyeFmdNkpKd1Jz.png",
      //   "score": 0,
      //   "pageSource": "工具完善-强制",
      //   "infoCompleteType": "A",
      //   "hasReceivedScore": false
      // }
      // userPlan.hasReceivedScore = false
      console.log('用户AB测试配置获取成功:', userPlan);
      return userPlan;
    } else {
      console.log('接口未返回有效的AB测试配置，将使用默认旧方案');
      userPlan = null;
      return null;
    }
  } catch (error) {
    console.error('获取用户AB测试配置异常:', error);
    userPlan = null;
    return null;
  }
}

async function getToolsInfoCompleteState(to, from) {
  cleanExpiredVisitRecords();
  if (to.meta.isNeedShowInfoComplete || to.path.includes('formula/evaluation') || to.path.includes('formula/treatment')) {
    // 需要进行完善信息弹窗的页面
    return await checkAndCountPageVisit(to);
  }
  return false;
}

async function getTNMDetailInfoCompleteState() {
  let to = {}
  to.name = "tnmDetail"
  return await checkAndCountPageVisit(to);
}

/**
 * 判断AB测试是否启用
 * @returns {boolean} 是否启用AB测试
 */
function isABTestEnabled() {
  // 使用全局参数判断
  return showTest && isInActiveTime;
}

/**
 * 获取用户所属的测试组
 * @param {string} userId - 用户ID
 * @returns {Object|null} 测试组配置对象，如果没有分配则返回null
 */
function getUserTestGroup(userId) {
  // 优先使用服务端返回的用户配置（接口获取的方案为主）
  if (userPlan && userPlan.infoCompleteType) {
    console.log(`用户 ${userId} 使用服务端AB测试方案: ${userPlan.name || userPlan.infoCompleteType}`);
    // 直接返回服务端的 userPlan，不需要从配置中查找
    return userPlan;
  }
  
  // 接口获取不到，返回 null，使用旧方案
  console.log(`用户 ${userId} 接口未返回AB测试配置，使用默认旧方案`);
  return null;
}

/**
 * 获取当前用户ID
 * @returns {string} 用户ID
 */
function getCurrentUserId() {
  let userId = '';
  
  // 尝试从 sessionStorage 获取用户信息
  try {
    const userInfoStr = localStorage.getItem('userinfoobjstr');
    if (userInfoStr) {
      const userInfo = JSON.parse(userInfoStr);
      if (userInfo && userInfo.userid) {
        userId = userInfo.userid;
        console.log('userInfo.userid', userId)
        return userId;
      }
    }
  } catch (error) {
    console.warn('获取用户信息失败:', error);
  }
  
  // 尝试从 sessionStorage 获取 userId
  const sessionUserId = sessionStorage.getItem('userId');
  if (sessionUserId) {
    userId = sessionUserId;
    console.log('sessionUserId', userId)
    return userId;
  }
  
  // 使用匿名ID作为备选
  const anonymousId = localStorage.getItem('AnonymousID');
  if (anonymousId) {
    userId = anonymousId;
    console.log('anonymousId', userId)
    return userId;
  }
  
  return 'guest'; // 默认访客ID
}

/**
 * 检查并计数页面访问，判断是否需要弹窗
 * @param {Object} to - 路由对象
 * @returns {Promise<boolean>} 是否需要弹窗
 */
async function checkAndCountPageVisit(to) {
  // ⚠️ 等待配置初始化完成，确保 userPlan 已经加载
  if (configInitPromise) {
    await configInitPromise;
    console.log('[时序保证] 配置初始化完成，userPlan 已加载');
  }
  
  // 获取当前用户ID
  const userId = getCurrentUserId();
  
  // 获取当前日期作为key
  const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD格式
  
  // 确定页面类别
  let pageCategory;
  if (to.path && to.path.includes('formula')) {
    pageCategory = 'formula';
  } else {
    pageCategory = to.name || 'unknown';
  }
  
  let shouldPopup = false;
  
  // 检查是否启用AB测试
  if (isABTestEnabled()) {
    // 启用AB测试，使用新规则
    const testGroup = getUserTestGroup(userId);
    
    if (testGroup) {
      console.log(`用户 ${userId} 所属测试组: ${testGroup.name || 'Unknown'}, 类型: ${testGroup.infoCompleteType}`);
      
      if (testGroup.infoCompleteType === 'A') {
        // A组规则：所有工具累计使用到第4次后，每次都弹出（不区分工具）
        // ⚠️ 只操作 user_popup_A_ 存储，不会影响 B组 和 默认方案
        console.log(`[互斥检查] A组用户只操作 user_popup_A_${today} 存储`);
        shouldPopup = checkAGroupPopup(userId, today);
      } else if (testGroup.infoCompleteType === 'B') {
        // B组规则：根据不同工具有不同计数方式
        // ⚠️ 只操作 user_popup_B_ 存储，不会影响 A组 和 默认方案
        console.log(`[互斥检查] B组用户只操作 user_popup_B_${today} 存储`);
        shouldPopup = checkBGroupPopup(userId, today, pageCategory);
      }
    } else {
      // 接口未返回有效配置，使用旧规则
      // ⚠️ 只操作 user_popup_default_ 存储，不会影响 A组 和 B组
      console.log(`[互斥检查] 默认方案用户只操作 user_popup_default_${today} 存储`);
      shouldPopup = checkDefaultGroupPopup(userId, today, pageCategory);
    }
  } else {
    // 未启用AB测试，使用旧规则
    // ⚠️ 只操作 user_popup_default_ 存储，不会影响 A组 和 B组
    console.log(`[互斥检查] 默认方案用户只操作 user_popup_default_${today} 存储`);
    shouldPopup = checkDefaultGroupPopup(userId, today, pageCategory);
  }
  
  return shouldPopup;
}

/**
 * A组弹窗逻辑：所有工具累计使用到第4次后，每次都弹出
 * ⚠️ 互斥保证：只操作 user_popup_A_ 存储
 * @param {string} userId - 用户ID
 * @param {string} today - 今日日期
 * @returns {boolean} 是否需要弹窗
 */
function checkAGroupPopup(userId, today) {
  const storageKey = `user_popup_A_${today}`;
  console.log(`[A组互斥] 只读写存储键: ${storageKey}`);
  
  let todayData = {};
  
  try {
    const stored = localStorage.getItem(storageKey);
    if (stored) {
      todayData = JSON.parse(stored);
    }
  } catch (error) {
    console.warn('读取A组弹窗记录失败:', error);
  }
  
  // 初始化用户数据
  if (!todayData[userId]) {
    todayData[userId] = {
      totalVisitCount: 0 // 所有工具总访问次数
    };
  }
  
  // 增加总访问计数
  todayData[userId].totalVisitCount++;
  const totalCount = todayData[userId].totalVisitCount;
  
  // 保存到本地存储
  try {
    localStorage.setItem(storageKey, JSON.stringify(todayData));
    console.log(`[A组互斥] 已保存到 ${storageKey}，totalVisitCount=${totalCount}`);
  } catch (error) {
    console.warn('保存A组弹窗记录失败:', error);
  }
  
  // 第4次及以后每次都弹窗
  if (totalCount >= 4) {
    console.log(`A组用户 ${userId} 今日第 ${totalCount} 次访问工具，触发弹窗`);
    return true;
  }
  
  console.log(`A组用户 ${userId} 今日第 ${totalCount} 次访问工具，未达到阈值`);
  return false;
}

/**
 * B组弹窗逻辑：根据不同工具有不同计数方式，今日只弹一次
 * ⚠️ 互斥保证：只操作 user_popup_B_ 存储
 * @param {string} userId - 用户ID
 * @param {string} today - 今日日期
 * @param {string} pageCategory - 页面类别
 * @returns {boolean} 是否需要弹窗
 */
function checkBGroupPopup(userId, today, pageCategory) {
  // 如果用户已领取积分，则不再弹窗
  if (userPlan && userPlan.hasReceivedScore === true) {
    console.log(`B组用户 ${userId} 已领取积分，不再弹窗`);
    return false;
  }
  
  const storageKey = `user_popup_B_${today}`;
  console.log(`[B组互斥] 只读写存储键: ${storageKey}`);
  
  let todayData = {};
  
  try {
    const stored = localStorage.getItem(storageKey);
    if (stored) {
      todayData = JSON.parse(stored);
    }
  } catch (error) {
    console.warn('读取B组弹窗记录失败:', error);
  }
  
  // 初始化用户数据
  if (!todayData[userId]) {
    todayData[userId] = {
      hasPopup: false, // 今天是否已经弹窗
      visitCounts: {} // 各页面访问计数
    };
  }
  
  // 初始化当前页面类别的计数
  if (!todayData[userId].visitCounts[pageCategory]) {
    todayData[userId].visitCounts[pageCategory] = 0;
  }
  
  // 增加访问计数
  todayData[userId].visitCounts[pageCategory]++;
  
  // 获取弹窗阈值
  const popupThresholds = getPopupThresholds();
  const threshold = popupThresholds[pageCategory] || popupThresholds.default;
  const currentCount = todayData[userId].visitCounts[pageCategory];
  const hasPopupToday = todayData[userId].hasPopup;
  
  // 判断是否需要弹窗：用户今天未弹窗 且 当前页面访问次数达到阈值
  const shouldPopup = !hasPopupToday && currentCount >= threshold;
  
  if (shouldPopup) {
    todayData[userId].hasPopup = true;
    console.log(`B组用户 ${userId} 页面 ${pageCategory} 第 ${currentCount} 次访问，触发弹窗`);
  }
  
  // 保存到本地存储
  try {
    localStorage.setItem(storageKey, JSON.stringify(todayData));
    console.log(`[B组互斥] 已保存到 ${storageKey}，页面 ${pageCategory} 访问 ${currentCount} 次`);
  } catch (error) {
    console.warn('保存B组弹窗记录失败:', error);
  }
  
  return shouldPopup;
}

/**
 * 默认（旧）方案弹窗逻辑：根据不同工具有不同计数方式，今日只弹一次
 * ⚠️ 互斥保证：只操作 user_popup_default_ 存储
 * @param {string} userId - 用户ID
 * @param {string} today - 今日日期
 * @param {string} pageCategory - 页面类别
 * @returns {boolean} 是否需要弹窗
 */
function checkDefaultGroupPopup(userId, today, pageCategory) {
  const storageKey = `user_popup_default_${today}`;
  console.log(`[默认方案互斥] 只读写存储键: ${storageKey}`);
  
  let todayData = {};
  
  try {
    const stored = localStorage.getItem(storageKey);
    if (stored) {
      todayData = JSON.parse(stored);
    }
  } catch (error) {
    console.warn('读取默认方案弹窗记录失败:', error);
  }
  
  // 初始化用户数据
  if (!todayData[userId]) {
    todayData[userId] = {
      hasPopup: false, // 今天是否已经弹窗
      visitCounts: {} // 各页面访问计数
    };
  }
  
  // 初始化当前页面类别的计数
  if (!todayData[userId].visitCounts[pageCategory]) {
    todayData[userId].visitCounts[pageCategory] = 0;
  }
  
  // 增加访问计数
  todayData[userId].visitCounts[pageCategory]++;
  
  // 获取弹窗阈值
  const popupThresholds = getPopupThresholds();
  const threshold = popupThresholds[pageCategory] || popupThresholds.default;
  const currentCount = todayData[userId].visitCounts[pageCategory];
  const hasPopupToday = todayData[userId].hasPopup;
  
  // 判断是否需要弹窗：用户今天未弹窗 且 当前页面访问次数达到阈值
  const shouldPopup = !hasPopupToday && currentCount >= threshold;
  
  if (shouldPopup) {
    todayData[userId].hasPopup = true;
    console.log(`默认方案用户 ${userId} 页面 ${pageCategory} 第 ${currentCount} 次访问，触发弹窗`);
  }
  
  // 保存到本地存储
  try {
    localStorage.setItem(storageKey, JSON.stringify(todayData));
    console.log(`[默认方案互斥] 已保存到 ${storageKey}，页面 ${pageCategory} 访问 ${currentCount} 次`);
  } catch (error) {
    console.warn('保存默认方案弹窗记录失败:', error);
  }
  
  return shouldPopup;
}

/**
 * 获取不同页面类别的弹窗阈值配置
 * @returns {Object} 阈值配置对象
 */
function getPopupThresholds() {
  return {
    formula: 3,        // formula页面访问3次弹窗一次
    default: 2,        // 其他页面默认2次弹窗一次
    TrjDetail: 1,
    tnmDetail: 3,
    // 可以根据具体页面名称设置不同阈值
    // 'page-name': 10,
  };
}

/**
 * 清理过期的访问记录（可选，用于定期清理本地存储）
 */
function cleanExpiredVisitRecords() {
  const today = new Date().toISOString().split('T')[0];
  
  // 清理2天前的记录（包括三种方案：A组、B组、默认方案）
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (key.startsWith('user_popup_A_') || 
                key.startsWith('user_popup_B_') || 
                key.startsWith('user_popup_default_'))) {
      // 提取日期部分
      let dateStr = '';
      if (key.startsWith('user_popup_A_')) {
        dateStr = key.replace('user_popup_A_', '');
      } else if (key.startsWith('user_popup_B_')) {
        dateStr = key.replace('user_popup_B_', '');
      } else if (key.startsWith('user_popup_default_')) {
        dateStr = key.replace('user_popup_default_', '');
      }
      
      if (dateStr) {
        const recordDate = new Date(dateStr);
        const daysDiff = (new Date(today) - recordDate) / (1000 * 60 * 60 * 24);
        
        if (daysDiff > 2) {
          localStorage.removeItem(key);
          i--; // 因为删除了一个项目，需要调整索引
        }
      }
    }
  }
}

// 将getUserInfoCompletePlan挂载到window对象，以便在H5登录后能同步调用
if (typeof window !== 'undefined') {
  window.getUserInfoCompletePlan = getUserInfoCompletePlan;
}

export default getToolsInfoCompleteState;
export { 
  getTNMDetailInfoCompleteState,
  getPrefectToastConfig,
  getUserInfoCompletePlan,
  waitForConfigInit,
  getUserPlan,
  prefectToastConfig,
  userPlan,
  showTest,
  isInActiveTime,
  isABTestEnabled,
  getUserTestGroup,
  configInitPromise
};
